import React from 'react';
import PropTypes from 'prop-types';
import Collapse from './Collapse';

const AdvancedSection = (props) => (
  <section
      className={`${
      props.isOpen ? 'advanced_section no-padding' : 'advanced_section__hide'
    }`}
  >
    <div className="sb-filter__section">
      <Collapse useHeightCalcs={false} isOpen={props.isOpen}>
        {props.children}
      </Collapse>
    </div>
  </section>
);

AdvancedSection.propTypes = {
    children: PropTypes.node.isRequired,
    isOpen: PropTypes.bool
};

export default AdvancedSection;



// WEBPACK FOOTER //
// ./src/client/components/AdvanceSection.js